export const styles = (theme) => ({
  container: {
    padding: 15,
  },
  headerStyle: {
    padding: "0px",
    zIndex: "0",
    fontSize: "12px",
    backgroundColor: "rgb(112, 112, 113)",
    color: "white",
  },
  checkTablePagination: {
    margin: 20,
    float: "right",
    opacity: 0.5,
  },
  checkedBox: {
    "&&:hover": {
      backgroundColor: "transparent",
    },
  },
  actionIcons: {
    padding: 8,
    boxShadow: "none",
    "&&:hover": {
      backgroundColor: "transparent",
    },
  },
  addRowSection: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
  },
  filterSection: {
    marginBottom: 15,
  },

  hidden: {
    display: "none",
  },

  riskCard: {
    textAlign: "center",
    border: "1px solid #F3F3F3",
    padding: 0,
  },
  riskCardContent: {
    borderBottom: "1px solid #F3F3F3",
    paddingBottom: 5,
    paddingTop: 5,
    display: "flex",
    justifyContent: "space-between",
  },
  riskCardEditButton: {
    width: 60,
    display: "flex",
    justifyContent: "flex-end",
  },
  riskCardContentScore: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    paddingTop: 5,
  },
});
